<div
  class="pg-slider-wrapper grit-slider-wrapper"
  (keyup)="_onKeyup()"
  (keydown)="_onKeydown($event)"
  (focus)="focus()"
  (blur)="onBlur()"
  tabindex="0"
>
  <div
    #slideBarNonFilled
    class="pg-slider-bar-nonfilled"
    (mousedown)="_onMousedown($event)"
  >
    <div
      #thumbLabel
      class="pg-thumb-label-container"
      (slideend)="_onDragEnd()"
      (slidestart)="_onDragStart()"
      (slide)="_onDrag($event)"
      (mousedown)="_onClickThumb($event)"
    >
      <span class="pg-thumb-label-content">
        <ng-content select="[pgLabel], [gritLabel]"></ng-content>
        {{ _dragging ? _onDraggingTickValue.value : _currentValue }}</span
      >
      <div
        #thumbLabelPositionIndicator
        class="pg-label-position-indicator"
      ></div>
    </div>
    <div #sliderBarFill class="pg-slider-bar-filled"></div>
    <div
      #thumb
      class="pg-slider-thumb"
      (slideend)="_onDragEnd()"
      (slidestart)="_onDragStart()"
      (slide)="_onDrag($event)"
      (mousedown)="_onClickThumb($event)"
    ></div>
  </div>
</div>
